import { Grid2 } from "@mui/material";
import TableCell from "../TableCell";
import CertificateStatus from "../../CertificateStatus";
import { createCertificateFileUrl, createTestPlanFileUrl } from "../../../helpers/urlBuilder";
import CertificateFileLink from "../../CertificateFileLink";
import LockIcon from "../../LockIcon";
import { stringToHtml } from "../../../helpers/string";
import { formatDate } from "../../../helpers/date";

const TableRow = ({ product, isApproved = false, isPremium = false }) => {
  const report = product?.lastRecord;

  return (
    <Grid2 container direction="row" size={12}>
      <Grid2 container direction="row" size={4}>
        <TableCell
          size={3}
          clearBorderTop clearBorderRight center
        >
          {isApproved ? report?.certificateNumber : <LockIcon />}
        </TableCell>
        <TableCell
          size={3}
          clearBorderTop clearBorderRight center
        >
          {formatDate(report?.testDate, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).replace(/\./ig, '-')}
        </TableCell>
        <TableCell
          size={3}
          clearBorderTop clearBorderRight bold center
        >
          <CertificateStatus status={report?.status} />
        </TableCell>
        <TableCell
          size={3}
          clearBorderTop clearBorderRight bold center
        >
          {
            isApproved ? (
              <>
                {
                  report?.certificateFileDE ? (
                    <CertificateFileLink fileUrl={createCertificateFileUrl(product?.id, 'de')} title={'DE'}
                                         fileAvailable={isApproved} />
                  ) : null
                }
                &nbsp;
                {
                  report?.certificateFileEN ? (
                    <CertificateFileLink fileUrl={createCertificateFileUrl(product?.id, 'en')} title={'EN'}
                                         fileAvailable={isApproved} />
                  ) : null
                }
              </>
            ) : <LockIcon />
          }
        </TableCell>
      </Grid2>
      <Grid2 container direction="row" size={isPremium ? 6 : 7}>
        <TableCell
          size={2}
          clearBorderTop clearBorderRight center
        >
          {product?.product_type?.productTypeName}
        </TableCell>
        <TableCell
          size={5}
          clearBorderTop clearBorderRight center
          html={stringToHtml(product?.productName || '')}
        />
        <TableCell
          size={5}
          clearBorderTop
          clearBorderRight
          center
          html={stringToHtml(product?.partList || '')}
        />
      </Grid2>
      {
        isPremium ? (
          <TableCell size={1} center clearBorderTop clearBorderRight>
            {
              report?.testPlanFile ? (
                <CertificateFileLink
                  fileUrl={createTestPlanFileUrl(report?.test_plan?.id)}
                  title={report?.test_plan?.testPlan}
                />
              ) : null
            }
          </TableCell>
        ) : null
      }
      <TableCell size={1} center clearBorderTop>
        {product?.classification?.classification}
      </TableCell>
    </Grid2>
  )
}

export default TableRow;